import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import api from '../../services/api';

const PageContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f5f7fa;
  padding: 2rem;
`;

const Card = styled.div`
  max-width: 500px;
  width: 100%;
  padding: 2rem;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  text-align: center;
`;

const Title = styled.h1`
  color: #4a90e2;
  margin-bottom: 1.5rem;
`;

const Message = styled.p`
  font-size: 1rem;
  color: #333;
  margin-bottom: 1.5rem;
  line-height: 1.6;
`;

const Button = styled.button`
  padding: 0.75rem 1.5rem;
  background-color: #4a90e2;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #357abd;
  }
`;

const VerifyEmail = () => {
  const [status, setStatus] = useState('loading'); // 'loading' | 'success' | 'error'
  const [errorMessage, setErrorMessage] = useState('');
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const hasRequestedRef = useRef(false);

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setErrorMessage('Verification token is missing.');
      return;
    }

    // Avoid double-calling the verify endpoint in React StrictMode dev
    if (hasRequestedRef.current) {
      return;
    }
    hasRequestedRef.current = true;

    const verify = async () => {
      try {
        await api.get(`/auth/verify-email?token=${encodeURIComponent(token)}`);
        setStatus('success');
      } catch (error) {
        console.error('Email verification error:', error);
        const message = error.response?.data?.message || 'Email verification failed. Please try again or request a new link.';
        setErrorMessage(message);
        setStatus('error');
      }
    };

    verify();
  }, [searchParams]);

  const handleGoToLogin = () => {
    navigate('/login', { replace: true });
  };

  return (
    <PageContainer>
      <Card>
        {status === 'loading' && (
          <>
            <Title>Verifying your email...</Title>
            <Message>Please wait while we confirm your email address.</Message>
          </>
        )}

        {status === 'success' && (
          <>
            <Title>Email Verified</Title>
            <Message>
              Your email has been verified successfully. You can now log in to your account.
            </Message>
            <Button onClick={handleGoToLogin}>Go to Login</Button>
          </>
        )}

        {status === 'error' && (
          <>
            <Title>Verification Problem</Title>
            <Message>{errorMessage}</Message>
            <Button onClick={handleGoToLogin}>Go to Login</Button>
          </>
        )}
      </Card>
    </PageContainer>
  );
};

export default VerifyEmail;
